export const nullifyWhenEmptyArray = <T extends unknown[]>(arg: T): T | null =>
  arg.length > 0 ? arg : null
